import axios from 'axios';
import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';

import { Config } from '../../common/config';
import AlertModal from '../../components/alertModal';
import LeftMenu from '../../components/leftMenu';
import {
  getFormattedDateTime,
  getErrorMessage,
  isSuccessResponse,
} from '../../components/utils';
import { getPostcode } from '../../components/zip';
import translations from '../../data/translation';
import LocaleDateInput from '../../components/LocaleDateInput';
import useAxiosFetch from '../../hooks/useAxiosFetch'; // 실제 경로에 맞게 수정
import useStoreNo from '../../hooks/useStoreNo';
import { userLogin } from '../../reducers/userInfo';

export default function UserManage() {
  const { fetchData } = useAxiosFetch();
  var script = document.createElement('script');
  script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
  document.head.appendChild(script);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector(state => state.userInfo);
  const storeNo = useStoreNo();
  const language = useSelector(state => state.language.language);
  const t = translations[language];

  const [modalOpen, setModalOpen] = useState(false); //모달 상태 관리 : 기본값 - 닫힘
  const [modalInfo, setModalInfo] = useState({
    isCancel: false,
    isConfirm: true,
    isMessage: true,
    headerMsg: '',
    actionFlag: '',
    error: '',
    mainMsg: '',
    action: '',
    isPercent: false,
  });
  const [userData, setUserData] = useState({});

  const [emailAuthNo, setEmailAuthNo] = useState('');
  const [smsAuthNo, setSmsAuthNo] = useState('');
  /** 서버에서 불러온 원본 (변경 여부 판별용) */
  const [baselineEmail, setBaselineEmail] = useState('');
  const [baselineMobileDigits, setBaselineMobileDigits] = useState('');
  /** 이메일/휴대폰이 원본과 다를 때 인증하기 완료 여부 */
  const [emailChangeVerified, setEmailChangeVerified] = useState(true);
  const [phoneChangeVerified, setPhoneChangeVerified] = useState(true);
  const [birthday, setBirthday] = useState('');
  const [, setDetailAddr] = useState('');
  const [regDttm, setRegDttm] = useState('');
  const [updDttm, setUpdDttm] = useState('');
  const [sms1, setSms1] = useState('');
  const [sms2, setSms2] = useState('');
  const [sms3, setSms3] = useState('');
  const [password, setPassword] = useState('');
  // Inline validation error messages
  const [currPwdError, setCurrPwdError] = useState('');
  const [newPwdError, setNewPwdError] = useState('');
  const [confirmPwdError, setConfirmPwdError] = useState('');
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [emailCodeError, setEmailCodeError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [smsCodeError, setSmsCodeError] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPassword1, setNewPassword1] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const [newPassword1Invalid, setNewPassword1Invalid] = useState(false);
  const [newPassword2Invalid, setNewPassword2Invalid] = useState(false);
  const [currPwdInvalid, setCurrPwdInvalid] = useState(false);
  const [showCurrPwd, setShowCurrPwd] = useState(false);
  const [showNewPwd1, setShowNewPwd1] = useState(false);
  const [showNewPwd2, setShowNewPwd2] = useState(false);
  let sms = '';
  let modUserData = {};

  const openModal = () => {
    if (modalInfo.actionFlag === 'verifySamePassword') {
      setModalInfo({
        ...modalInfo,
        mainMsg: '비밀번호가 일치하지 않습니다(대소문자 구분).',
      });
    } else if (modalInfo.actionFlag === 'pwd') {
      // 비밀번호 변경 모달을 열 때 항상 비밀번호 입력값 초기화
      setPassword('');
      setNewPassword('');
      setNewPassword1('');
      setNewPassword2('');
      setNewPassword1Invalid(false);
      setNewPassword2Invalid(false);
      setCurrPwdInvalid(false);
    } else if (modalInfo.actionFlag === 'mail') {
      setModalInfo({ ...modalInfo, mainMsg: `메일을 보내는 중입니다.....` });
    } else if (modalInfo.actionFlag === 'getEmailAuth') {
      setModalInfo({
        ...modalInfo,
        mainMsg: '이메일 인증번호받기를 해주세요.',
      });
    } else if (modalInfo.actionFlag === 'verifyEmailError') {
      setModalInfo({
        ...modalInfo,
        mainMsg: '이메일 인증번호가 다릅니다. 다시 해주세요',
      });
    } else if (modalInfo.actionFlag === 'verifyEmail') {
      setModalInfo({ ...modalInfo, mainMsg: '이메일 인증 해주세요.' });
    } else if (modalInfo.actionFlag === 'SMS') {
      setModalInfo({ ...modalInfo, mainMsg: `SMS를 보내는 중입니다.....` });
    } else if (modalInfo.actionFlag === 'getSMSAuth') {
      setModalInfo({
        ...modalInfo,
        mainMsg: '휴대폰 인증번호받기를 해주세요.',
      });
    } else if (modalInfo.actionFlag === 'verifySMSError') {
      setModalInfo({
        ...modalInfo,
        mainMsg: '휴대폰 인증번호가 다릅니다. 다시 해주세요',
      });
    } else if (modalInfo.actionFlag === 'verifySMS') {
      setModalInfo({ ...modalInfo, mainMsg: '휴대폰 번호 인증 해주세요.' });
    } else if (modalInfo.actionFlag === 'api') {
      setModalInfo({
        ...modalInfo,
        mainMsg: 'API 서버에러입니다. 잠시 후 다시 시도해주세요.',
      });
    }

    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    if (modalInfo.actionFlag === 'pwd') {
      setPassword('');
      setNewPassword('');
      setNewPassword1('');
      setNewPassword2('');
      modalInfo.error = '';
      modalInfo.isMessage = true;
    }
  };

  const doModal = () => {
    setModalOpen(false);

    if (modalInfo.actionFlag === 'pwd') {
      // 유효성 검사 통과 시 바로 비밀번호 변경 진행
      if (validatePwdFields()) {
        executePwdChange();
      }
    } else if (modalInfo.actionFlag === 'login') {
      navigate('/login');
    }
  };

  // 비밀번호 입력값 유효성 검사 — 실패 시 pwd 모달 다시 열고 false 반환
  const validatePwdFields = () => {
    if (!password || !newPassword1 || !newPassword2) {
      setCurrPwdInvalid(false);
      setModalInfo({
        ...modalInfo,
        actionFlag: 'pwd',
        isMessage: false,
        error: '모든 비밀번호 항목을 입력해 주세요.',
      });
      setModalOpen(true);
      return false;
    }
    if (password === newPassword1) {
      setCurrPwdInvalid(false);
      setNewPassword1Invalid(true);
      setModalInfo({
        ...modalInfo,
        actionFlag: 'pwd',
        isMessage: false,
        error: '기존 비밀번호와 신규 비밀번호를 다르게 입력하세요.',
      });
      setModalOpen(true);
      return false;
    }
    if (!validatePassword(newPassword1)) {
      setNewPassword1Invalid(true);
      setNewPassword2Invalid(false);
      setModalInfo({
        ...modalInfo,
        actionFlag: 'pwd',
        isMessage: false,
        error:
          '신규 비밀번호는 영문, 숫자, 특수문자 중 2가지 이상 조합 8~16자로 입력해 주세요.\n3자 이상 동일한 숫자/문자는 사용이 불가합니다.',
      });
      setModalOpen(true);
      return false;
    }
    if (newPassword1 !== newPassword2) {
      setNewPassword1Invalid(false);
      setNewPassword2Invalid(true);
      setModalInfo({
        ...modalInfo,
        actionFlag: 'pwd',
        isMessage: false,
        error: '신규 비밀번호와 신규 비밀번호 확인을 같게 입력하세요.',
      });
      setModalOpen(true);
      return false;
    }
    return true;
  };

  // 실제 비밀번호 변경 API 호출
  const executePwdChange = async () => {
    try {
      const ret = await axios.post(
        `${Config.API_SERVER}changePwd`,
        { password, newPassword: newPassword1 },
        { withCredentials: true },
      );
      const chkPwdResult = ret?.data?.data?.chkPwdResult;
      if (chkPwdResult === true) {
        setModalInfo({
          ...modalInfo,
          actionFlag: '',
          isMessage: true,
          isConfirm: true,
          error: '',
          mainMsg: '비밀번호가 성공적으로 변경되었습니다.',
        });
        setModalOpen(true);
        setPassword('');
        setNewPassword1('');
        setNewPassword2('');
      } else {
        setCurrPwdInvalid(true);
        setNewPassword1Invalid(false);
        setNewPassword2Invalid(false);
        setModalInfo({
          ...modalInfo,
          actionFlag: 'pwd',
          isMessage: false,
          error: '기존 비밀번호가 일치하지 않습니다.',
        });
        setModalOpen(true);
      }
    } catch (err) {
      const isUnauthorized =
        err?.response?.status === 401 ||
        err?.response?.data?.resultCode === 401;
      if (isUnauthorized) {
        setCurrPwdInvalid(true);
        setNewPassword1Invalid(false);
        setNewPassword2Invalid(false);
      }
      setModalInfo({
        ...modalInfo,
        actionFlag: 'pwd',
        isMessage: false,
        error: isUnauthorized
          ? '기존 비밀번호가 일치하지 않습니다.'
          : '비밀번호 변경에 실패했습니다.',
      });
      setModalOpen(true);
    }
  };

  // JWT refresh handled centrally in useAxiosFetch

  const getData = useCallback(async () => {
    try {
      const ret = await fetchData({
        url: Config.API_SERVER + `detail/${userInfo.id}`,
        method: 'get',
      });
      if (ret?.data?.data) {
        const row = ret.data.data;
        setUserData(row);
        setBaselineEmail((row.email || '').trim());
        setBirthday(row.birthday ? row.birthday.slice(0, 10) : '');
        let mobileDigits = '';
        if (row.mobile) {
          const cleaned = String(row.mobile).replace(/\D/g, '');
          mobileDigits = cleaned.length >= 10 ? cleaned.slice(0, 11) : cleaned;
          if (cleaned.length >= 10) {
            setSms1(cleaned.slice(0, 3));
            setSms2(cleaned.slice(3, 7));
            setSms3(cleaned.slice(7, 11));
          }
        } else {
          setSms1('');
          setSms2('');
          setSms3('');
        }
        setBaselineMobileDigits(mobileDigits);
        setEmailChangeVerified(true);
        setPhoneChangeVerified(true);
        setEmailAuthNo('');
        setSmsAuthNo('');
        setDetailAddr(row.detAddr || '');
        setRegDttm(getFormattedDateTime(row.regDttm));
        setUpdDttm(getFormattedDateTime(row.updDttm));
      }
    } catch (error) {
      console.error('Error getData:', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.id]);
  const validatePassword = pwd => {
    // 비밀번호의 길이가 8에서 16자 사이인지 확인
    if (pwd.length === 0 || pwd.length < 8 || pwd.length > 16) {
      return false;
    } else {
      // 영문, 숫자, 특수문자 중 2가지 이상을 포함하는지 확인
      let hasUpperCase = false;
      let hasLowerCase = false;
      let hasNumber = false;
      let hasSpecialChar = false;

      const specialChars = '!"#$%&\'()*+,-./:;>=<?@[\\]^_`{|}~';

      for (let i = 0; i < pwd.length; i++) {
        const char = pwd.charAt(i);

        if (char >= 'a' && char <= 'z') {
          hasLowerCase = true;
        } else if (char >= 'A' && char <= 'Z') {
          hasUpperCase = true;
        } else if (char >= '0' && char <= '9') {
          hasNumber = true;
        } else if (specialChars.includes(char)) {
          hasSpecialChar = true;
        }
      }

      const conditions = [
        hasUpperCase,
        hasLowerCase,
        hasNumber,
        hasSpecialChar,
      ];
      const countTrue = conditions.filter(condition => condition).length;
      if (countTrue < 2) {
        return false;
      } else {
        // 동일한 문자가 3번 이상 연속으로 나오는지 확인
        for (let i = 0; i < pwd.length - 2; i++) {
          if (pwd[i] === pwd[i + 1] && pwd[i] === pwd[i + 2]) {
            return false;
          }
        }
      }
    }
    return true;
  };

  const getEmailAuthNo = async () => {
    try {
      if (userData.email === null || userData.email === undefined) {
        setModalInfo({
          ...modalInfo,
          isConfirm: true,
          mainMsg: '메일을 입력하신 후 다시 해주세요!',
        });
        setModalOpen(true);
        return;
      }
      if (userData.email.length > 0) {
        // 서버가 이름을 필수로 받으므로(비면 영어 오류) 인증번호 요청 전에 먼저 막는다.
        if (!(userData.userName || userData.adminName)) {
          setModalInfo({
            ...modalInfo,
            isConfirm: true,
            mainMsg: '이름을 입력해 주세요.',
          });
          setModalOpen(true);
          return;
        }
        modUserData.email = userData.email;
        modalInfo.actionFlag = 'mail';
        modalInfo.isConfirm = false;
        openModal();
        const data = {
          adminId: userData.adminId,
          adminName: userData.userName || userData.adminName,
          password: userData.pwd || 'Temp1234!',
          email: userData.email,
        };

        const ret = await fetchData({
          url: `${Config.API_SERVER}profile-auth/email/send`,
          method: 'post',
          data,
        });

        if (ret.data.data.emailAuthNo) {
          setEmailAuthNo('');
          setModalOpen(false);
          setModalInfo({
            ...modalInfo,
            isConfirm: true,
            mainMsg: '인증번호를 메일에서 확인하고 직접 입력해 주세요.',
          });
          setModalOpen(true);
        } else {
          setModalOpen(false);
          modalInfo.actionFlag = 'api';
          modalInfo.isConfirm = true;
          openModal();
        }
      } else {
        setModalInfo({
          ...modalInfo,
          isConfirm: true,
          mainMsg: '메일을 입력하신 후 다시 해주세요!',
        });
        setModalOpen(true);
        return;
      }
    } catch (error) {
      setModalOpen(false);
      const status = error.response?.status;
      const serverMsg = error.response?.data?.message;
      if (error.response?.data?.resultCode === 401) {
        modalInfo.actionFlag = 'login';
        modalInfo.mainMsg = '유효기간이 만료되었으니 다시 로그인해주세요';
        setModalOpen(true);
      } else if (status === 500 || status === 503) {
        setModalInfo({
          ...modalInfo,
          actionFlag: 'api',
          isConfirm: true,
          mainMsg:
            serverMsg ||
            '인증 메일을 보내지 못했습니다. 잠시 후 다시 시도하거나 관리자에게 문의해 주세요.',
        });
        setModalOpen(true);
      }
      console.error('Error getData:', error);
    }
  };

  const validateEmailAuthNo = async () => {
    try {
      const emailCodeDigits = String(emailAuthNo).replace(/[^0-9]/g, '');
      if (emailCodeDigits.length === 6) {
        const data = {
          adminId: userData.adminId,
          emailAuthNo: Number(emailCodeDigits),
        };
        const ret = await fetchData({
          url: `${Config.API_SERVER}profile-auth/email/verify`,
          method: 'post',
          data,
        });

        if (ret?.data?.data?.verifyResult) {
          setEmailChangeVerified(true);
          setModalInfo({
            ...modalInfo,
            mainMsg: '이메일 인증번호가 확인 되었습니다.',
          });
          setModalOpen(true);
        } else {
          modalInfo.actionFlag = 'verifyEmailError';
          openModal();
        }
      } else {
        setModalInfo({
          ...modalInfo,
          isConfirm: true,
          mainMsg: '이메일 인증번호 6자리를 입력해 주세요.',
        });
        setModalOpen(true);
      }
    } catch (error) {
      if (error.response?.data?.resultCode === 401) {
        modalInfo.actionFlag = 'login';
        modalInfo.mainMsg = '유효기간이 만료되었으니 다시 로그인해주세요';
        setModalOpen(true);
      }
      console.error('Error getData:', error);
    }
  };

  const validateSMS = () => {
    // 휴대폰번호의 길이 확인
    if (sms1.length !== 3 || sms2.length !== 4 || sms3.length !== 4) {
      modalInfo.mainMsg =
        '휴대폰 번호를 숫자(3자리)-숫자(4자리)-숫자(3자리)로 넣어주세요.';
      return false;
    } else {
      // 숫자인지 확인
      const hasNumber1 = !isNaN(sms1);
      const hasNumber2 = !isNaN(sms2);
      const hasNumber3 = !isNaN(sms3);

      if (hasNumber1 & hasNumber2 & hasNumber3) {
        sms = sms1 + '-' + sms2 + '-' + sms3;
        return true;
      } else {
        modalInfo.mainMsg =
          '휴대폰 번호를 숫자(3자리)-숫자(4자리)-숫자(3자리)로 넣어주세요.';
        return false;
      }
    }
  };

  const getSMSAuthNo = async () => {
    try {
      const validSMS = validateSMS();
      if (validSMS) {
        const data = {
          password: 'string',
          adminId: userInfo.id,
          mobile: sms,
        };
        const ret = await fetchData({
          url: `${Config.API_SERVER}profile-auth/sms/send`,
          method: 'post',
          data,
        });

        if (ret?.data?.data?.mobileAuthNo) {
          setSmsAuthNo('');
          setModalInfo({
            ...modalInfo,
            mainMsg: '인증번호를 문자로 확인하고 직접 입력해 주세요.',
          });
          setModalOpen(true);
        } else {
          // API 에러...
          modalInfo.actionFlag = 'api';
          openModal();
        }
      } else {
        setModalInfo({ ...modalInfo });
        setModalOpen(true);
      }
    } catch (error) {
      if (error.response?.data?.resultCode === 401) {
        modalInfo.actionFlag = 'login';
        modalInfo.mainMsg = '유효기간이 만료되었으니 다시 로그인해주세요';
        setModalOpen(true);
      }
      console.error('Error getData:', error);
    }
  };

  const validateSMSAuthNo = async () => {
    try {
      const smsCodeDigits = String(smsAuthNo).replace(/[^0-9]/g, '');
      if (smsCodeDigits.length === 6) {
        const data = {
          adminId: userData.adminId,
          mobileAuthNo: Number(smsCodeDigits),
        };
        const ret = await fetchData({
          url: `${Config.API_SERVER}profile-auth/sms/verify`,
          method: 'post',
          data,
        });

        if (ret.data.data.verifyResult) {
          setPhoneChangeVerified(true);
          setModalInfo({
            ...modalInfo,
            mainMsg: '휴대폰인증번호가 확인 되었습니다.',
          });
          setModalOpen(true);
        } else {
          // API 에러...
          modalInfo.actionFlag = 'verifySMSError';
          openModal();
        }
      } else {
        setModalInfo({
          ...modalInfo,
          isConfirm: true,
          mainMsg: '휴대폰 인증번호 6자리를 입력해 주세요.',
        });
        setModalOpen(true);
      }
    } catch (error) {
      if (error.response?.data?.resultCode === 401) {
        modalInfo.actionFlag = 'login';
        modalInfo.mainMsg = '유효기간이 만료되었으니 다시 로그인해주세요';
        setModalOpen(true);
      }
      console.error('Error getData:', error);
    }
  };

  const validateEmail = email => {
    // 문자열 형식 검사
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
  };

  const checkUserData = () => {
    // userName 또는 adminName 둘 중 하나라도 있으면 통과
    if (!(userData.userName || userData.adminName)) {
      modalInfo.mainMsg = '이름을 입력해 주세요.';
      return false;
    }
    if (!birthday) {
      modalInfo.mainMsg = '생년월일을 입력해 주세요.';
      return false;
    }

    if (userData.email) {
      if (validateEmail(userData.email) === false) {
        modalInfo.mainMsg = '이메일 주소가 유효하지 않습니다.';
        return false;
      }
    }
    if (sms1) {
      const validSMS = validateSMS();
      if (!validSMS) {
        return false;
      }
    }

    return true;
  };

  const modUser = async () => {
    try {
      if (checkUserData() === true) {
        const emailNow = (userData.email || '').trim();
        const emailDiffers = emailNow !== (baselineEmail || '').trim();
        const phoneDigits = `${sms1}${sms2}${sms3}`.replace(/\D/g, '');
        const phoneDiffers = phoneDigits !== baselineMobileDigits;

        if (emailDiffers && !emailChangeVerified) {
          setModalInfo({
            ...modalInfo,
            mainMsg:
              '이메일을 변경한 경우 인증번호 받기 후 인증하기까지 완료한 뒤 저장해 주세요.',
            isConfirm: true,
            isMessage: true,
          });
          setModalOpen(true);
          return;
        }
        if (phoneDiffers && !phoneChangeVerified) {
          setModalInfo({
            ...modalInfo,
            mainMsg:
              '휴대폰 번호를 변경한 경우 인증번호 받기 후 인증하기까지 완료한 뒤 저장해 주세요.',
            isConfirm: true,
            isMessage: true,
          });
          setModalOpen(true);
          return;
        }

        // zipCode, addr, detAddr를 userData에서 항상 반영
        const reqData = {
          adminName: userData.userName || userData.adminName || '',
          role: userData.role || '',
          birthday: birthday,
          // 성별은 선택 항목 — 미선택('')을 보내면 서버 검증(M/F)에 걸려 영어 오류가 뜨므로 아예 보내지 않는다.
          ...(userData.gender ? { gender: userData.gender } : {}),
          email: userData.email || '',
          mobile: sms.length > 0 ? sms : userData.mobile || '',
          zipCode: userData.zipCode !== undefined ? userData.zipCode : '',
          addr: userData.addr !== undefined ? userData.addr : '',
          detAddr: userData.detAddr !== undefined ? userData.detAddr : '',
          acceptAgree: userData.acceptAgree || '',
        };
        if (newPassword) {
          reqData.pwd = newPassword;
        }

        // 관리자 정보 저장
        const ret = await fetchData({
          url: `${Config.API_SERVER}detail/${userInfo.id}`,
          method: 'put',
          data: reqData,
        });
        if (isSuccessResponse(ret)) {
          setBaselineEmail(emailNow);
          const md = (reqData.mobile || '').replace(/\D/g, '');
          setBaselineMobileDigits(md.length >= 10 ? md.slice(0, 11) : md);
          setEmailChangeVerified(true);
          setPhoneChangeVerified(true);
          // Update persisted user info (mobile, address) in Redux
          dispatch(
            userLogin({
              ...userInfo,
              mobile: reqData.mobile,
              zipCode: reqData.zipCode,
              addr: reqData.addr,
              detAddr: reqData.detAddr,
            })
          );
          setModalInfo({
            ...modalInfo,
            mainMsg: '요청정보를 성공적으로 수정하였습니다.',
            isMessage: true,
            isConfirm: true,
            error: '',
          });
          setModalOpen(true);
        } else {
          setModalInfo({
            ...modalInfo,
            mainMsg: getErrorMessage(ret),
            isMessage: true,
            isConfirm: true,
            error: '',
          });
          setModalOpen(true);
        }
      } else {
        setModalInfo({ ...modalInfo });
        setModalOpen(true);
      }
    } catch (error) {
      console.error('API Error:', error);
      setModalInfo({
        ...modalInfo,
        mainMsg: getErrorMessage(error?.response),
        isMessage: true,
        isConfirm: true,
        error: '',
      });
      setModalOpen(true);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.id]);

  return (
    <>
      <AlertModal
        open={modalOpen}
        close={closeModal}
        action={doModal}
        header={modalInfo.headerMsg}
        error={modalInfo.error}
        isConfirm={modalInfo.isConfirm}
        isMessage={modalInfo.isMessage}
        isCancel={modalInfo.isCancel}
      >
        {modalInfo.actionFlag === 'pwd' ? (
          <table className="login_box">
            <tbody>
              <tr>
                <th>{t.currentPassword}</th>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <div
                      className={currPwdInvalid ? 'input_wrapper_invalid' : ''}
                      style={{ flex: 1 }}
                    >
                      <input
                        className="input_03"
                        type={showCurrPwd ? 'text' : 'password'}
                        maxLength={16}
                        onChange={e => {
                          const raw = e.target.value;
                          setCurrPwdError('');
                          setCurrPwdInvalid(false);
                          setPassword(raw);
                        }}
                        value={password}
                      />
                      {currPwdInvalid && (
                        <span className="input_invalid_label">일치하지 않음</span>
                      )}
                    </div>
                    <button
                      type="button"
                      onClick={() => setShowCurrPwd(v => !v)}
                      aria-label={showCurrPwd ? '비밀번호 숨기기' : '비밀번호 보기'}
                      style={{
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        fontSize: 16,
                        lineHeight: 1,
                        padding: 0,
                      }}
                    >
                      {showCurrPwd ? (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>
                      ) : (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" /><circle cx="12" cy="12" r="3" /></svg>
                      )}
                    </button>
                  </div>
                  {currPwdError && (
                    <div className="font_red">{currPwdError}</div>
                  )}
                </td>
              </tr>
              <tr>
                <th>{t.newPassword}</th>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <div
                      className={
                        newPassword1Invalid ? 'input_wrapper_invalid' : ''
                      }
                      style={{ flex: 1 }}
                    >
                      <input
                        className="input_03"
                        type={showNewPwd1 ? 'text' : 'password'}
                        maxLength={16}
                        onChange={e => {
                          const raw = e.target.value;
                          setNewPwdError('');
                          setNewPassword1Invalid(false);
                          setNewPassword1(raw);
                        }}
                        value={newPassword1}
                      />
                      {newPassword1Invalid && (
                        <span className="input_invalid_label">사용 불가</span>
                      )}
                    </div>
                    <button
                      type="button"
                      onClick={() => setShowNewPwd1(v => !v)}
                      aria-label={showNewPwd1 ? '비밀번호 숨기기' : '비밀번호 보기'}
                      style={{
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        fontSize: 16,
                        lineHeight: 1,
                        padding: 0,
                      }}
                    >
                      {showNewPwd1 ? (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>
                      ) : (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" /><circle cx="12" cy="12" r="3" /></svg>
                      )}
                    </button>
                  </div>
                  {newPwdError && <div className="font_red">{newPwdError}</div>}
                </td>
              </tr>
              <tr>
                <th>{t.confirmNewPassword}</th>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <div
                      className={
                        newPassword2Invalid ? 'input_wrapper_invalid' : ''
                      }
                      style={{ flex: 1 }}
                    >
                      <input
                        className="input_03"
                        type={showNewPwd2 ? 'text' : 'password'}
                        maxLength={16}
                        onChange={e => {
                          const raw = e.target.value;
                          setConfirmPwdError('');
                          setNewPassword2Invalid(false);
                          setNewPassword2(raw);
                        }}
                        value={newPassword2}
                      />
                      {newPassword2Invalid && (
                        <span className="input_invalid_label">일치하지 않음</span>
                      )}
                    </div>
                    <button
                      type="button"
                      onClick={() => setShowNewPwd2(v => !v)}
                      aria-label={showNewPwd2 ? '비밀번호 숨기기' : '비밀번호 보기'}
                      style={{
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        fontSize: 16,
                        lineHeight: 1,
                        padding: 0,
                      }}
                    >
                      {showNewPwd2 ? (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>
                      ) : (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" /><circle cx="12" cy="12" r="3" /></svg>
                      )}
                    </button>
                  </div>
                  {confirmPwdError && (
                    <div className="font_red">{confirmPwdError}</div>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <>{modalInfo.mainMsg}</>
        )}
      </AlertModal>

      <section className="location_box location_box_mypage">
        <ul className="location_001">
          <li>
            <NavLink to={storeNo ? `/${storeNo}/gift-list` : '/gift-list'}>
              {t.home}
            </NavLink>
          </li>
          <li>{t.userManagement}</li>
        </ul>
      </section>

      <main>
        <section className="contants_box contants_box_mypage">
          <LeftMenu pageName="user" />

          <section className="rightcontant_box">
            <h2 className="tit_01">{t.userManagement}</h2>

            <article className="form_card contants_box_03">
              <table className="member_box">
                <tbody>
                  <tr>
                    <th>{t.username}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          type="text"
                          style={{ backgroundColor: '#ddd' }}
                          disabled
                          value={
                            userData && userData.adminId ? userData.adminId : ''
                          }
                          placeholder={t.username}
                        />
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.changePassword}</th>
                    <td>
                      <button
                        type="button"
                        className="button_05 button_gray"
                        onClick={e => {
                          modalInfo.actionFlag = 'pwd';
                          modalInfo.isMessage = false;
                          openModal(e);
                        }}
                      >
                        {t.changePassword}
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.name}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          type="text"
                          maxLength={80}
                          value={
                            userData.userName !== undefined
                              ? userData.userName
                              : userData.adminName || ''
                          }
                          placeholder={t.name}
                          onChange={e => {
                            const raw = e.target.value;
                            if (/^[A-Za-z가-힣\s]*$/.test(raw)) {
                              setNameError('');
                            } else {
                              setNameError(
                                '이름은 한글 또는 영문으로만 입력해주세요.'
                              );
                            }
                            setUserData({
                              ...userData,
                              userName: raw.replace(/[^A-Za-z가-힣\s]/g, ''),
                            });
                          }}
                        />
                      </form>
                      {nameError && <div className="font_red">{nameError}</div>}
                    </td>
                  </tr>
                  <tr>
                    <th>{t.birthday}</th>
                    <td>
                      <form>
                        <LocaleDateInput
                          className="input_01"
                          value={birthday ? birthday : ''}
                          placeholderText={t.birthday}
                          onChange={val => setBirthday(val)}
                        />
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.gender}</th>
                    <td>
                      <form>
                        <select
                          className="input_01"
                          name="gender"
                          value={userData ? userData.gender || '' : ''}
                          onChange={e => {
                            setUserData({
                              ...userData,
                              gender: e.target.value,
                            });
                          }}
                        >
                          <option value="">{t.gender}</option>
                          <option value="M">{t.male}</option>
                          <option value="F">{t.female}</option>
                        </select>
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.email}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          type="text"
                          maxLength={80}
                          placeholder="example@example.com"
                          value={
                            userData && userData.email ? userData.email : ''
                          }
                          onChange={e => {
                            const raw = e.target.value;
                            const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                              raw
                            );
                            setEmailError(
                              isValid || raw === ''
                                ? ''
                                : '올바른 이메일 형식이 아닙니다.'
                            );
                            setUserData({ ...userData, email: raw });
                            setEmailChangeVerified(
                              (raw || '').trim() ===
                                (baselineEmail || '').trim()
                            );
                          }}
                        />
                        <button
                          type="button"
                          className="button_05 button_gray"
                          onClick={getEmailAuthNo}
                        >
                          {t.requestEmailAuth}
                        </button>
                      </form>
                      {emailError && (
                        <div className="font_red">{emailError}</div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>{t.validateEmailAuth}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          type="text"
                          maxLength={6}
                          inputMode="numeric"
                          autoComplete="one-time-code"
                          value={emailAuthNo}
                          onChange={e => {
                            const raw = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 6);
                            setEmailCodeError('');
                            setEmailAuthNo(raw);
                          }}
                        />
                        <button
                          type="button"
                          className="button_05 button_gray"
                          onClick={validateEmailAuthNo}
                        >
                          {t.validateEmailAuth}
                        </button>
                      </form>
                      {emailCodeError && (
                        <div className="font_red">{emailCodeError}</div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>{t.phoneNumber}</th>
                    <td>
                      <form>
                        <input
                          className="input_02"
                          type="text"
                          maxLength={3}
                          value={sms1 || ''}
                          placeholder="010"
                          onChange={e => {
                            const raw = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 3);
                            setPhoneError('');
                            setSms1(raw);
                            const d = `${raw}${sms2}${sms3}`.replace(/\D/g, '');
                            setPhoneChangeVerified(d === baselineMobileDigits);
                          }}
                        />
                        -
                        <input
                          className="input_02"
                          type="text"
                          maxLength={4}
                          value={sms2 || ''}
                          placeholder="1234"
                          onChange={e => {
                            const raw = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 4);
                            setPhoneError('');
                            setSms2(raw);
                            const d = `${sms1}${raw}${sms3}`.replace(/\D/g, '');
                            setPhoneChangeVerified(d === baselineMobileDigits);
                          }}
                        />
                        -
                        <input
                          className="input_02"
                          type="text"
                          maxLength={4}
                          value={sms3 || ''}
                          placeholder="5678"
                          onChange={e => {
                            const raw = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 4);
                            setPhoneError('');
                            setSms3(raw);
                            const d = `${sms1}${sms2}${raw}`.replace(/\D/g, '');
                            setPhoneChangeVerified(d === baselineMobileDigits);
                          }}
                        />
                        <button
                          type="button"
                          className="button_05 button_gray"
                          onClick={getSMSAuthNo}
                        >
                          {t.requestSMSAuth}
                        </button>
                      </form>
                      {phoneError && (
                        <div className="font_red">{phoneError}</div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>{t.validateSMSAuth}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          type="text"
                          maxLength={6}
                          inputMode="numeric"
                          autoComplete="one-time-code"
                          value={smsAuthNo}
                          onChange={e => {
                            const raw = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 6);
                            setSmsCodeError('');
                            setSmsAuthNo(raw);
                          }}
                        />
                        <button
                          type="button"
                          className="button_05 button_gray"
                          onClick={validateSMSAuthNo}
                        >
                          {t.validateSMSAuth}
                        </button>
                      </form>
                      {smsCodeError && (
                        <div className="font_red">{smsCodeError}</div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>{t.address}</th>
                    <td>
                      <div className="signup_04">
                        <form>
                          <input
                            className="input_01"
                            //type="text"
                            id="postcode"
                            placeholder="우편번호"
                            value={userData ? userData.zipCode : ''}
                            onChange={e =>
                              setUserData({
                                ...userData,
                                zipCode: e.target.value,
                              })
                            }
                          />
                          <button
                            type="button"
                            className="button_05 button_gray"
                            onClick={() => {
                              // getPostcode에 setUserData와 userData를 넘겨서 주소값 반영
                              getPostcode(setUserData, userData);
                            }}
                          >
                            {t.search}
                          </button>
                          <br />
                          <input
                            className="input_03"
                            //type="text"
                            id="roadAddress"
                            placeholder="도로명주소"
                            value={
                              userData && userData.addr ? userData.addr : ''
                            }
                            onChange={e =>
                              setUserData({ ...userData, addr: e.target.value })
                            }
                          />
                          <input
                            className="input_03"
                            //type="text"
                            id="jibunAddress"
                            placeholder="지번주소"
                            hidden={true}
                            value={
                              userData && userData.jibunAddress
                                ? userData.jibunAddress
                                : ''
                            }
                            onChange={e =>
                              setUserData({
                                ...userData,
                                jibunAddress: e.target.value,
                              })
                            }
                          />
                          <span
                            id="guide"
                            style={{ color: '#999', display: 'none' }}
                          ></span>
                          <input
                            className="input_03"
                            type="text"
                            id="detailAddress"
                            maxLength={64}
                            placeholder="상세주소"
                            value={
                              userData && userData.detAddr
                                ? userData.detAddr
                                : ''
                            }
                            onChange={e =>
                              setUserData({
                                ...userData,
                                detAddr: e.target.value,
                              })
                            }
                          />
                          <input
                            className="input_03"
                            type="text"
                            id="extraAddress"
                            placeholder="참고항목"
                            hidden={true}
                            value={
                              userData && userData.extraAddress
                                ? userData.extraAddress
                                : ''
                            }
                            onChange={e =>
                              setUserData({
                                ...userData,
                                extraAddress: e.target.value,
                              })
                            }
                          />
                        </form>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.registrationDate}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          style={{ backgroundColor: '#ddd' }}
                          type="text"
                          disabled
                          value={regDttm || ''}
                        />
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.modificationDate}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          style={{ backgroundColor: '#ddd' }}
                          type="text"
                          disabled
                          value={updDttm || ''}
                        />
                      </form>
                    </td>
                  </tr>
                </tbody>
              </table>
            </article>

            <article className="button_box_01">
              <NavLink to={`/${userInfo.storeNo}/gift-list`}>
                <button
                  type="button"
                  className="button_01 button_03 button_gray_line"
                >
                  {t.cancel}
                </button>
              </NavLink>
              <button
                type="button"
                className="button_01 button_03 button_red"
                onClick={() => {
                  // 입력값을 userData에 반영 (userName 강제 덮어쓰기 제거, detAddr은 userData에 이미 반영)
                  setUserData(prev => ({
                    ...prev,
                    birthday: birthday,
                    gender: prev.gender || '',
                    email: prev.email || '',
                    mobile: [sms1, sms2, sms3].filter(Boolean).join('-'),
                  }));
                  setTimeout(() => {
                    modUser();
                  }, 0);
                }}
              >
                {t.save}
              </button>
            </article>
          </section>
        </section>
      </main>
    </>
  );
}
